export default {
  "content": "<path d=\"M0 0h32v32H0z\" fill=\"none\"/><g fill=\"#3F4450\"><path d=\"M25.71 0H6.29A2.293 2.293 0 004 2.29v27.42A2.293 2.293 0 006.29 32h19.42A2.293 2.293 0 0028 29.71V2.29A2.293 2.293 0 0025.71 0zM26 29.71c0 .157-.133.29-.29.29H6.29a.295.295 0 01-.29-.29V2.29c0-.157.133-.29.29-.29h19.42c.157 0 .29.133.29.29z\"/><path d=\"M8 25h16V4H8zm2-19h12v17H10z\"/><circle cx=\"16\" cy=\"27.5\" r=\"1.5\"/></g>",
  "attrs": {
    "viewBox": "0 0 32 32",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};